module.exports = __webpack_public_path__ + "static/media/google.9c42fec8.jpg";